import { reduxKey } from './constants';
// PopoverTypes shared between projects
export var PopoverType;
(function (PopoverType) {
    PopoverType["ADD_TO_COLLECTION"] = "ADD_TO_COLLECTION";
    PopoverType["ADD_TO_GROUP_PRIMARY"] = "ADD_TO_GROUP_PRIMARY";
    PopoverType["ADD_TO_GROUP_SECONDARY"] = "ADD_TO_GROUP_SECONDARY";
})(PopoverType || (PopoverType = {}));
//# sourceMappingURL=types.js.map